module.exports = __webpack_public_path__ + "img/piloncillo.13f18e82.jpg";